<ramme-med-tittel [tittel]="'Oppsummering av resultater fra seneste spørreundersøkelser'|translate">
  <ramme-innhold>
    <spoerreundersoekelse-korellert-resultatliste [resultater]="senesteUndersoekelseResultater()!" tittel=""/>
    @if (paagaaende().length > 0 && !lasterData()) {
      <tips>{{ 'Oppsummeringen inneholder ikke data fra aktive spørreundersøkelser'|translate }}</tips>
    } @else if (lukkede().length == 0 && !lasterData()) {
      <tips>{{ 'Oppsummerte data vises når første spørreundersøkelse er gjennomført'|translate }}</tips>
    }
  </ramme-innhold>
</ramme-med-tittel>

<ramme-med-tittel>
  <ramme-tittel>
    {{ 'Aktive spørreundersøkelser'|translate }}
    @if (brukerKanRedigere()) {
      <button mat-icon-button color="primary" (click)="opprettNy()">
        <mat-icon>add_circle</mat-icon>
      </button>
    }
  </ramme-tittel>
  <ramme-innhold data-testid="aktive-undersoekelser">
    @if (paagaaende().length == 0) {
      <div class="ingen-aktive-undersoekelser">
        {{ 'Ingen aktive spørreundersøkelser'|translate }},
        <a class="opprett-knapp" (click)="opprettNy()">{{ 'opprett en ny spørreundersøkelse'|translate }}</a>
      </div>
    } @else {
      @for (undersoekelse of paagaaende(); track undersoekelse.id) {
        <spoerreundersoekelse-listevisning [undersoekelse]="undersoekelse"/>
      }
    }
  </ramme-innhold>
</ramme-med-tittel>

@if (ikkePaagaaende().length > 0) {
  <ramme-med-tittel [tittel]="'Inaktive spørreundersøkelser'|translate">
    <ramme-innhold data-testid="inaktive-undersoekelser">
      @for (undersoekelse of ikkePaagaaende(); track undersoekelse.id) {
        <spoerreundersoekelse-listevisning [undersoekelse]="undersoekelse"/>
      }
    </ramme-innhold>
  </ramme-med-tittel>
}
